<!-- eslint-disable-next-line vue/valid-template-root-->
<template>
    <div class="tables-container" ref="tablesCharts"></div>
</template>

<script>
import loadGoogleCharts from '@/components/Dashboard/GoogleChartLoader.js'
import {getIndicatorKeys, getIndicatorNames} from "./StrataDashboardHelperFunctions";

export default {
    name: "TablesCharts",
    props: {
        data: {
            type: [Array, Object],
            default: () => []
        }
    },
    data: () => ({
        google: null,
        chart: null,
        timeoutToResize: null
    }),
    methods: {
        loadTables() {
            this.tableChart = new this.google.visualization.DataTable();
            let tableData = this.loadData(this.data);
            let rowData = tableData.slice(1);
            // first column/region label
            this.tableChart.addColumn('string', tableData[0][0]);
            let rowLabels = tableData[0].slice(1);
            // indicator labels
            rowLabels.forEach((label) => {
                this.tableChart.addColumn('number', label);
            });
            
            this.tableChart.addRows(rowData);

            this.drawTables()
        },
        drawTables() {
            var table = new this.google.visualization.Table(this.$refs.tablesCharts);
            var options = {
                showRowNumber: false, 
                width: '100%', 
                height: '100%',
                page: 'enable',
                pageSize: 20,
                // hotfix to wrap table headers
                // https://stackoverflow.com/questions/32234962/google-charts-api-re-enable-column-header-wrapping
                cssClassNames: {
                    headerCell: 'googleHeaderCell'
                }
            }
            this.chart = table;
            table.draw(this.tableChart, options);
            this.$emit('table-chart', this.chart);
        },
        loadData(output_data){
            let feature_collection = output_data.datasets[0].data;
            let features = feature_collection.features;
            let indicator_keys = getIndicatorKeys(feature_collection);
            let indicator_names = getIndicatorNames(indicator_keys);
            let column_titles = ["REGION NAME"];
            column_titles = column_titles.concat(indicator_names)
            if(feature_collection.properties && feature_collection.properties.default_property_name){
                column_titles.push(feature_collection.properties.default_property_name)
            } else {
                column_titles.push("STRATA SCORE")
            }
            

            let data = []
            data.push(column_titles)
            features.forEach(feature => {
                let featureData = []
                featureData.push(String(feature.properties.region_name))
                indicator_keys.forEach(indicator_key => {
                    featureData.push(feature.properties[indicator_key])
                })
                featureData.push(feature.properties.region_value)
                data.push(featureData);
            })
            return data;
        }
    },
    mounted() {
        loadGoogleCharts("current", { packages: ["table"] }).then((google) => {
            this.google = google;
            this.loadTables();
        });
    },
}
</script>
<style scoped>
.googleHeaderCell {
    /* I'm sorry this is here, but it's a weird hotfix to wrap the column header */
}
</style>